import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Delta } from 'quill';

@Component({
    selector: 'rich-text-editor',
    templateUrl: './rich-text-editor.component.html',
    styleUrls: ['./rich-text-editor.component.scss']
})
export class RichTextEditorComponent {
    @Input() hasCancel = true;
    @Input() hasSave = true;
    @Input() content: Delta | string | undefined;
    @Input() placeholderText = 'Insert text here...';
    @Output() saveEdit = new EventEmitter<Delta | string>();
    @Output() cancelEdit = new EventEmitter();

    hasTyped = false;

    onFirstInput() {
        if (!this.hasTyped) {
            this.hasTyped = true;
        }
    }

    onSave() {
        this.saveEdit.emit(this.content);
        this.content = '';
    }

    onCancel() {
        this.cancelEdit.emit();
    }
}
